import {defineMessages, FormattedMessage} from 'react-intl';
import {Text, Overlay} from 'src/v2/components/common';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import {useSelector} from 'src/v2/state/store';
import {WalletRegistry} from 'src/v2/util/WalletRegistry';

const messages = defineMessages({
  confirm: {
    id: 'crypto.payins.v2.network_switching.confirm_network_switch',
    description:
      'Prompt to tell the user to confirm the transaction in MetaMask',
    defaultMessage: 'Confirm network update',
  },
});

export const NetworkSwitchingOverlay = () => {
  const activeWallet = useSelector(
    (state) => state.walletConnection.activeWallet,
  );

  if (!activeWallet) {
    throw new Error(
      'activeWallet is required in SetupConfirmationPendingOverlay',
    );
  }

  const walletOption = WalletRegistry.getWalletOption({
    provider: activeWallet.type,
    key: activeWallet.key,
  });

  if (!walletOption) {
    throw new Error('Wallet option not found in NetworkSwitchingOverlay');
  }

  return (
    <Overlay name="network-switching">
      <WalletIcon walletOption={walletOption} />
      <Text type="title" css={{textColor: 'inherit'}}>
        <FormattedMessage {...messages.confirm} />
      </Text>
    </Overlay>
  );
};
